import { Component, effect, ElementRef, inject, OnDestroy, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WebsocketLaravelReverb } from '../../services';
import { CHANNEL_ATRIL_PANTALLA_NAME, END_EXPERIENCE_EVENT, SHOW_SAY_GOOD_BYE_VIEW_EVENT } from '../../config';
import { CustomRouteService } from 'src/app/pages/custom-route/services';

@Component({
  selector: 'app-say-good-bye-view',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './say-good-bye-view.component.html',
  styleUrls: ['./say-good-bye-view.component.scss'],
})
export class SayGoodByeViewComponent {
  public sayGoodByeRef = viewChild<ElementRef | null>('sayGoodByeViewRef');
  
  private _customRouteService = inject(CustomRouteService);
  private _webSocketLaravelReverbService = inject(WebsocketLaravelReverb);
  
  private _routeToken = this._customRouteService.token;
  
  showGoodByeView = effect(() => {
    const ref = this.sayGoodByeRef();
    if (!ref) return;
    
    const el = ref.nativeElement as HTMLElement;
    
    this._showSayGoodByeViewSubscription(this._routeToken(), el);
  })
  
  private _showSayGoodByeViewSubscription(token: string, el: HTMLElement): void {
    this._webSocketLaravelReverbService
    .subscribeToChannel(
      CHANNEL_ATRIL_PANTALLA_NAME,
      SHOW_SAY_GOOD_BYE_VIEW_EVENT + token
    ).subscribe({
      next: (_data: any) => {
        el.classList.add('fade-in');
      },
      error: (err: any) => console.error('Error en canal:', err)
    });
  }
}
